// Class of every swiper slide the player renders
export const SWIPER_SLIDE = "swiper-slide tw:[border:solid_1px_transparent]";

// The image inside a slide, in a shop window
export const SLIDE_IMAGE_CLASS =
  "slide-image tw:[.landscape_.shop-window_.swiper-slide_&]:[margin:15%_15%_10%_15%] tw:[.portrait_.shop-window_.swiper-slide_&]:m-[5px]";
